// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6533":"61b4c9334f43ec3a","8914":"d47e4f3ff15ec2c4","13678":"57cb0da95d0342cc","28398":"b6323009d4472833","28880":"51ce930283c4921a","48846":"6438dbb375600f1b","64558":"3dd81c0e18a02d8d","80082":"e8dec7efcdc6dc08"}[chunkId] + ".css";
};